module.exports = __webpack_public_path__ + "static/media/fire_grey_big.e0974bf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/icons/fire_grey_big.png
// module id = ./src/assets/media/icons/fire_grey_big.png
// module chunks = 16